var _rect, _path, _g, _rect2, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeaturePublic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 128,
    viewBox: "0 0 160 128",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Public services and accessible documents") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 36,
    width: 78,
    height: 74,
    rx: 7,
    fill: "#D7E0EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62 16v20M63 17h23v13H63",
    stroke: "#A27A5F",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#A6B2C2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 49,
    width: 13,
    height: 12,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 49,
    width: 13,
    height: 12,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79,
    y: 49,
    width: 11,
    height: 12,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 70,
    width: 13,
    height: 12,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 70,
    width: 13,
    height: 12,
    rx: 2
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 91,
    width: 20,
    height: 19,
    rx: 3,
    fill: "#45556D"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(7 118 82)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 49,
    width: 45,
    height: 62,
    rx: 6,
    fill: "#45556D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104 63h25M104 74h20",
    stroke: "#D7E0EB",
    strokeWidth: 3.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m106 94 6 6 12-14",
    stroke: "#93BAA3",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturePublic);
export default __webpack_public_path__ + "static/media/feature-public.1e5106d047c66744c4cd9ead76c5818d.svg";
export { ForwardRef as ReactComponent };